import React from 'react';

interface QRDownloadPopupProps {
  open: boolean;
  onClose: () => void;
}

const QRDownloadPopup: React.FC<QRDownloadPopupProps> = ({ open, onClose }) => {
  if (!open) return null;
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl p-8 mx-4 text-center font-normal max-w-sm w-full" onClick={(e) => e.stopPropagation()}>
        <div className="text-xl font-bold mb-4 text-black">
          폰피쉬 앱 다운로드
        </div>
        <div className="text-base font-normal mb-6 text-gray-700 leading-relaxed">
          더 나은 쇼핑 경험을 위해<br />
          폰피쉬 앱을 다운로드해보세요!
        </div>
        
        {/* QR 코드 이미지 */}
        <div className="mb-6 flex justify-center">
          <img 
            src="/ic_app_download_qr.png" 
            alt="앱 다운로드 QR 코드" 
            className="w-48 h-48 object-contain"
          />
        </div>
        
        <div className="text-sm text-gray-600 mb-6">
          QR 코드를 스캔하여<br />
          앱을 다운로드하세요
        </div>
        
        <div className="flex flex-col gap-3">
          <button
            className="px-6 py-3 bg-black text-white rounded-full font-semibold hover:bg-gray-800 transition text-base"
            onClick={() => {
              window.open('https://about.ponpish.co.kr/hidden/app-download', '_blank');
              onClose();
            }}
          >
            직접 다운로드
          </button>
          <button
            className="px-6 py-2 bg-gray-200 text-gray-700 rounded-full font-semibold hover:bg-gray-300 transition text-sm"
            onClick={onClose}
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default QRDownloadPopup;
